<template>
  <mdb-container>
    <div class="d-none">{{ computedId }}</div>
    <mdb-select
      search
      @getValue="getSelectValue"
      v-model="labelOptions"
      :visibleOptions="6"
      :label="$t('retailer')"
      :placeholder="$t('choose_retailer')"
    />
  </mdb-container>
</template>

<script>
import { mdbSelect, mdbContainer } from "mdbvue";

export default {
  name: "RetailerChainMemberSelection",
  props: {
    retailerChainId: Number,
    retailerId: Number,
  },
  components: {
    mdbSelect,
    mdbContainer,
  },
  data: () => ({
    loadReady: false,
    members: null,
    labelOptions: [],
    retailerchainmemberspath: "/1.0/front/retailers/bychain/",
  }),
  watch: {
    retailerChainId: function (newVal, oldVal) {
      if (newVal !== 0 /*&& this.members !== null*/) {
        this.getRetailerChainMembers();
      }
      console.log("Prop changed: ", newVal, " | was: ", oldVal);
    },
  },
  methods: {
    checkRetailerChainId() {
      this.labelOptions = [];
      var defaultSelection =
        this.retailerId === 0 ? this.members[0].id : this.retailerId;
      this.members.forEach(function (member) {
        this.labelOptions.push({
          text: member.name + ", " + member.addr1,
          value: member.id,
          selected: defaultSelection === member.id ? true : false,
        });
      }, this);
    },
    getSelectValue(val) {
      var member = this.members.find(({ id }) => id === val);
      this.$emit("member", member);
    },
    getRetailerChainMembers() {
      if (this.retailerChainId != 0) {
        this.$http
          .get(this.retailerchainmemberspath + this.retailerChainId)
          .then((response) => {
            if (response.status == 200) {
              this.members = response.data.retailers;
              this.checkRetailerChainId();
              this.loadReady = true;
            } else if (response.status == 401) {
              this.$root.$emit("session_failed");
            }
          })
          .catch((error) => {
            return error;
          });
      }
    },
  },
  computed: {
    /*computedId: function () {
      this.getChainMembers();
      return this.retailerChainId;
    },*/
  },
  mounted() {
    this.getRetailerChainMembers();
  },
};
</script>

<style>
.form-control {
  color: #495057;
}
</style>
